import { render, staticRenderFns } from "./BannerMembership.vue?vue&type=template&id=85ee025a&"
import script from "./BannerMembership.vue?vue&type=script&lang=js&"
export * from "./BannerMembership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports